// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-input textarea {\n  max-height: 42px;\n}\n.header-input .ui-input.form-group.m-form__group {\n  padding: 0;\n}\n.header-input input:disabled,\n.header-input textarea:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
